import { VStack, HStack, Text, useMediaQuery } from '@chakra-ui/react'
import React from 'react'

const Sidebar = ({ dates, onDaySelect, addDate, orderCounter, reservationsCounter }: any) => {
  const [isMobile] = useMediaQuery('(max-width: 768px)')

  const getOrderCounter = (date: any) => {
    if (orderCounter) {
      const exists = orderCounter.find((dateObj: any) => {
        if (dateObj.date ?? null) {
          return dateObj.date === date
        }
      })
      if (exists) {
        return exists.count
      }
    }

    return 0
  }

  if (isMobile) {
    return (
      <HStack bg='blackAlpha.200' px={4} spacing={4} left={0} py={4} overflowX='scroll' w='full'>
        {dates &&
          dates.map(({ date, name, active }: any) => {
            return (
              <VStack
                key={date}
                spacing={0}
                alignItems='left'
                borderRadius={5}
                w='full'
                py={1}
                px={4}
                bg={active ? 'green.600' : 'blackAlpha.200'}
                _hover={{ background: 'green.400', color: 'white' }}
                color={active ? 'white' : 'black'}
                cursor='pointer'
                onClick={() => onDaySelect(date)}
                minWidth={125}
                position='relative'
              >
                <Text>{name}</Text>
                <Text>{date}</Text>
                {getOrderCounter(date) > 0 && (
                  <Text
                    position='absolute'
                    top={0}
                    right={0}
                    background='red.600'
                    color='white'
                    borderRadius={5}
                    paddingX={1.5}
                    paddingY={1}
                    fontSize={12}
                    fontWeight='bold'
                  >
                    x{getOrderCounter(date)}
                  </Text>
                )}
                {reservationsCounter && (
                  <Text
                    position='absolute'
                    bottom={0}
                    right={0}
                    background='yellow.400'
                    color='black'
                    borderRadius={5}
                    paddingX={1.5}
                    paddingY={1}
                    fontSize={12}
                    fontWeight='bold'
                  >
                    {reservationsCounter[date] ?? 0}
                  </Text>
                )}
              </VStack>
            )
          })}
      </HStack>
    )
  }
  return (
    <VStack
      minHeight='100vh'
      height='100%'
      px={4}
      spacing={4}
      position='absolute'
      left={0}
      top={20}
      py={4}
      w={48}
      overflowY='scroll'
      zIndex={999}
      bg="#ebebeb"
    >
      <VStack
        spacing={0}
        alignItems='left'
        borderRadius={5}
        py={0}
        px={4}
        textAlign='center'
        bg='blackAlpha.200'
        _hover={{ background: 'green.400', color: 'white' }}
        color='black'
        cursor='pointer'
        onClick={() => addDate(false)}
      >
        <Text fontSize={16} fontWeight='bold'>
          +
        </Text>
      </VStack>
      {dates &&
        dates.map(({ date, name, active }: any) => {
          return (
            <VStack
              key={date}
              spacing={0}
              alignItems='left'
              borderRadius={5}
              w='full'
              py={1}
              px={4}
              bg={active ? 'green.600' : 'blackAlpha.200'}
              _hover={{ background: 'green.400', color: 'white' }}
              color={active ? 'white' : 'black'}
              cursor='pointer'
              onClick={() => onDaySelect(date)}
              position='relative'
            >
              <Text>{name}</Text>
              <Text>{date}</Text>
              {getOrderCounter(date) > 0 && (
                <Text
                  position='absolute'
                  top={0}
                  right={0}
                  background='red.600'
                  color='white'
                  borderRadius={5}
                  paddingX={1.5}
                  paddingY={1}
                  fontSize={12}
                  fontWeight='bold'
                >
                  x{getOrderCounter(date)}
                </Text>
              )}
              {reservationsCounter && (<Text
                position='absolute'
                bottom={0}
                right={0}
                background='yellow.400'
                color='black'
                borderRadius={5}
                paddingX={1.5}
                paddingY={1}
                fontSize={12}
                fontWeight='bold'
              >
                {reservationsCounter[date] ?? 0}
              </Text>)}
            </VStack>
          )
        })}
      <VStack
        spacing={0}
        alignItems='left'
        borderRadius={5}
        py={0}
        px={4}
        textAlign='center'
        bg='blackAlpha.200'
        _hover={{ background: 'green.400', color: 'white' }}
        color='black'
        cursor='pointer'
        onClick={addDate}
      >
        <Text fontSize={16} fontWeight='bold'>
          +
        </Text>
      </VStack>
    </VStack>
  )
}

export default Sidebar
